<template>
  <v-row
    class="pa-1"
    align="start"
    justify="start"
    :style="{ 'min-height': rowMinHeight }"
    v-if="show"
  >
    <v-flex v-if="label" :class="$style['label']" row style="max-width: 280px !important;">
      <Label :label="label" :name="name" />
      <RequiredTag :show="isRequired || isItemRequired" :required-if="isRequiredIf"/>
    </v-flex>
    <div class="flex-grow-1 d-flex align-center">
      <template v-if="type === 'file'">
        <FileField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :display-stored-file="displayStoredFile"
          :stored-file="storedFile"
          :width="width"
          :accept="accept"
        />
      </template>
      <template v-else-if="type === 'textarea'">
        <TextareaField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :width="width"
          :placeholder="placeholder"
        />
      </template>
      <template v-else-if="type === 'select'">
        <SelectField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :options="optionType != null ? options : selects"
          :text-key="textKey"
          :value-key="valueKey"
          :multiple="multiple"
          :limit="limit"
          :width="width"
        />
      </template>
      <template v-else-if="type === 'select-all'">
        <SelectAllField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :options="optionType != null ? options : selects"
          :text-key="textKey"
          :value-key="valueKey"
          :multiple="multiple"
          :limit="limit"
          :width="width"
        />
      </template>
      <template v-else-if="type === 'select-reviewset'">
        <SelectReviewSetField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :options="optionType != null ? options : selects"
          :text-key="textKey"
          :value-key="valueKey"
          :multiple="multiple"
          :limit="limit"
          :width="width"
        />
      </template>
      <template v-else-if="type === 'date'">
        <DateField v-model="localValue" :name="name" :label="label" :rules="rules" :width="width"
                   :remarks="remarks" />
      </template>
      <template v-else-if="type === 'datetime'">
        <DateTimeField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :width="width"
        />
      </template>
      <template v-else-if="type === 'number'">
        <NumberField v-model="localValue" :name="name" :label="label" :rules="rules" />
      </template>
      <template v-else-if="type === 'currency'">
        <CurrencyField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :min="min"
          :width="width"
          :placeholder="placeholder"
          :unit="unit"
        />
      </template>
      <template v-else-if="type === 'radio'">
        <RadioField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :options="optionType != null ? options : selects"
          :text-key="textKey"
          :value-key="valueKey"
          :column="column"
          :width="width"
        />
      </template>
      <template v-else-if="type === 'checkbox'">
        <CheckboxField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :options="optionType != null ? options : selects"
          :text-key="textKey"
          :value-key="valueKey"
          :checkedIds="checkedIds"
          :remarks="remarks"
          :disabled="disabled"
        ></CheckboxField>
      </template>
      <template v-else-if="type === 'condiments'">
        <CondimentFields
                v-model="localValue"
                :defaultValue="localValue"
                :name="name"
                :label="label"
                :rules="rules"
                :options="optionType != null ? options : selects"
                :text-key="textKey"
                :value-key="valueKey"
                :checkedIds="checkedIds"
                :remarks="remarks"
                :disabled="disabled"
        ></CondimentFields>
      </template>
      <template v-else-if="type === 'conditions'">
        <ConditionFields
                :input.sync="localValue"
                :defaultValue="localValue"
                :name="name"
                :label="label"
                :rules="rules"
                :options="optionType != null ? options : selects"
                :text-key="textKey"
                :value-key="valueKey"
                :checkedIds="checkedIds"
                :remarks="remarks"
                :disabled="disabled"
                :conditionError="conditionError"
        ></ConditionFields>
      </template>
      <template v-else-if="type === 'display'">
        <DisplayField
          :value="localValue"
          :render="render"
          :as="as"
          :option="option"
          :remarks="remarks"
        />
      </template>
      <template v-else-if="type === 'display-reviewset'">
        <DisplayReviewSetField
          :value="localValue"
          :render="render"
          :as="as"
          :option="option"
          :remarks="remarks"
          :name="name"
        />
      </template>
      <template v-else-if="type === 'display-fixeditem'">
        <DisplayFixedItemField />
      </template>
      <template v-else-if="type === 'images'">
        <Images
                :value="localValue"
                :render="render"
                :as="as"
                :option="option"
                :remarks="remarks"
        />
      </template>
      <template v-else-if="type === 'image'">
        <ImageField
                :value="localValue"
                :render="render"
                :as="as"
                :option="option"
                :remarks="remarks"
        />
      </template>
      <template v-else-if="type === 'video'">
        <VideoField :value="localValue" :option="option" :name="name" />
      </template>
      <template v-else-if="type === 'password'">
        <PasswordField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :ref-name="refName"
        />
      </template>
      <template v-else-if="type === 'passwordIssueBtn'">
        <PasswordIssueBtn v-model="localValue" :pk="pk" />
      </template>
      <template v-else-if="type === 'custom'">
        <slot :name="name" />
      </template>
      <template v-else>
        <TextField
          v-model="localValue"
          :name="name"
          :label="label"
          :rules="rules"
          :width="width"
          :remarks="remarks"
          :unit="unit"
          :placeholder="placeholder"
        />
      </template>
    </div>
  </v-row>
</template>

<script>
import Label from "./label";
import FileField from "./file";
import TextareaField from "./textarea";
import SelectField from "./select";
import SelectAllField from "./select-all";
import SelectReviewSetField from "./select-reviewset";
import DateField from "./date";
import DateTimeField from "./datetime";
import NumberField from "./number";
import CurrencyField from "./currency";
import RadioField from "./radio";
import CheckboxField from "./checkbox";
import TextField from "./text";
import DisplayField from "./display";
import DisplayFixedItemField from "./display-fixeditem";
import DisplayReviewSetField from "./display-reviewset";
import VideoField from "./video";
import PasswordField from "./password";
import RequiredTag from "./tag/required";
import PasswordIssueBtn from "../custom/password-issue-btn";
import Images from "./images";
import ImagesList from "./images-list";
import TextListField from "./text-list";
import CondimentFields from "./condiments";
import ImageField from "./images-imput";
import ConditionFields from "./conditions";

export default {
  components: {
    Label,
    FileField,
    TextareaField,
    SelectField,
    SelectAllField,
    SelectReviewSetField,
    DateField,
    DateTimeField,
    NumberField,
    CurrencyField,
    RadioField,
    CheckboxField,
    TextField,
    DisplayField,
    DisplayFixedItemField,
    DisplayReviewSetField,
    VideoField,
    PasswordField,
    RequiredTag,
    PasswordIssueBtn,
    Images,
    ImagesList,
    TextListField,
    CondimentFields,
    ImageField,
    ConditionFields
  },
  props: {
    value: {
      required: true
    },
    type: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: [String, Object]
    },
    refName: {
      type: String
    },
    optionType: {
      type: [String, Array]
    },
    textKey: {
      type: String
    },
    valueKey: {
      type: String
    },
    multiple: {
      type: Boolean
    },
    limit: {
      type: Number
    },
    as: {
      type: String,
      default: "default"
    },
    render: {
      type: Function,
      default: value => value
    },
    option: {
      type: Function,
      default: () => {}
    },
    displayStoredFile: {
      type: Boolean,
      default: false
    },
    storedFile: {
      type: String,
      default: ""
    },
    rowMinHeight: {
      type: String,
      default: "40px"
    },
    selects: {
      type: Array
    },
    checkedIds: {
      type: Array
    },
    width: {
      type: String
    },
    min: {
      type: Number
    },
    placeholder: {
      type: String
    },
    pk: {
      type: String
    },
    show: {
      type: Boolean,
      default: true
    },
    remarks: {
      type: String
    },
    column: {
      type: Boolean
    },
    accept: {
      type: String
    },
    unit: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    entityProductIds: {
      type: Array,
      default: () => ([])
    },
    conditionError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    options() {
      return this.$store.getters[`${this.optionType}/options/options`];
    },
    isRequiredIf() {
      return ((this.rules || "").match(/required_if/g) || []).length > 0;
    },
    isRequired() {
      return ((this.rules || "").match(/required/g) || []).length > 0;
    },
    isItemRequired() {
      return ((this.itemRules || "").match(/required/g) || []).length > 0;
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  created() {
    if (this.optionType) {
      if (this.isProvider && this.optionType === 'common/products' && this.type !== 'display') {
        this.$store.commit(`${this.optionType}/options/initialize`);
      }else {
        this.$store.dispatch(`${this.optionType}/options/index`);
      }
    }
  }
};
</script>

<style module lang="scss">
.label {
  width: 280px !important;
  max-width: 280px !important;
  min-height: 37px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

label,
strong {
  font-size: 14px !important;
}
</style>
